import { Features } from 'generated/featureDefinitions'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import MoneyWithCurrency from 'modules/core/lib/money'

import { useExpenses } from 'modules/expenses/pages/ExpensesContext'

export const useManagedExpensesLimits = () => {
  const { loading, refetch, featureAvailability } = useFeatureAvailability(
    Features.expenses_monthly_managed_expenses
  )

  const { featureAvailabilities } = useExpenses()

  const {
    access: { locale },
  } = useCurrentSession()

  const limitReached = () => {
    return !!(
      featureAvailabilities.packagingPaywallsEnabled &&
      !featureAvailability.available &&
      'usageLimit' in featureAvailability &&
      featureAvailability.usageLimit
    )
  }

  const limitNearlyReached = () => {
    if (
      !featureAvailabilities.packagingPaywallsEnabled ||
      !featureAvailability.available ||
      !('usageLimit' in featureAvailability)
    )
      return false

    if (
      !featureAvailability.usage ||
      !featureAvailability.usageLimit ||
      featureAvailability.usageLimit == -1
    )
      return false

    return featureAvailability.usage / featureAvailability.usageLimit >= 0.9
  }

  const unitPrice = () => {
    if ('usageLimit' in featureAvailability && featureAvailability.currencyCode) {
      return MoneyWithCurrency({
        amount: Number(featureAvailability.additionalUnitPrice) * 100,
        currency: featureAvailability.currencyCode,
        locale,
      })
    }
  }

  const usageLimit = () => {
    if ('usageLimit' in featureAvailability) {
      return featureAvailability.usageLimit
    }
  }

  const extraUsage = () => {
    if (
      limitReached() &&
      'usageLimit' in featureAvailability &&
      featureAvailability.usage &&
      featureAvailability.usageLimit
    ) {
      return featureAvailability.usage - featureAvailability.usageLimit
    }
  }

  return {
    loading,
    refetch,
    limitReached: limitReached(),
    limitNearlyReached: limitNearlyReached(),
    usageLimit: usageLimit(),
    unitPrice: unitPrice(),
    extraUsage: extraUsage(),
  }
}
